export default __webpack_public_path__ + "static/media/primebond-active.0790a47e.png";